import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas() {

      this.canvasChart = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.trend.x}, ${this.trend.y})`)

      this.draw_ChartAxis() //-----> below
      this.draw_Grid() //-----> below
    },

    
    draw_ChartAxis() {
      let axes = this.canvasChart
      axes
      .append('line')
      .attr('x1', 0).attr('x2', this.trend.width).attr('y1', this.trend.height).attr('y2', this.trend.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      axes // Primary Axis
      .append('text')
      .attr('transform', `translate(${-this.primary.padding}, ${this.trend.height/2 +  this.primary.tSize*0.4}) rotate(-90)`)
      .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.primary.title)
    },


    draw_Grid() {
      let tick = this.trend.height / 5
      let grids = this.canvasChart

      for(let i=0; i<6; i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.trend.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .3)

        grids // Primary Axis
        .append('text')
        .attr('id', `GRID_${i}_${this.localId}`)
        .attr('x', -2).attr('y', this.trend.height - (tick * i) + 3)  
        .attr('font-size', 9).attr('fill', '#757575')
        .attr('text-anchor', 'end')
        .text(()=> {
          let value = (this.primary.max * (i*.2)).toFixed(0)
          if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
          return value + this.primary.unit
        })
      }
    },


    draw_Timeline() {    

      let Timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(${0}, ${this.trend.height + .5})`)

      this.timeline.xItems.forEach(d=> {

        Timeline
        .append('line')
        .attr('x1', d.mx).attr('y1', 0)
        .attr('x2', d.mx).attr('y2', 3)
        .attr('stroke', '#757575').attr('stroke-width', .5)

        Timeline 
        .append('text')
        .attr('x', d.mx).attr('y', 10 + this.timeline.tSize*0.36)  
        .attr('font-size', this.timeline.tSize).attr('fill', this.timeline.tColor)
        .attr('text-anchor', 'middle')
        .text(`${d.name.substr(8,2)}/${d.name.substr(5,2)}`)
      })

    }, 


    draw_barChart() {
      let bar = this.canvasChart
      .append('g')
      .attr('transform', `translate(${0}, ${-.5})`)

      this.timeline.xItems.forEach((d,i)=> { 
        
        let data = this.trendData.find(f=> f[this.ref.item] == this.current && f[this.ref.timeline] == d.name)
        let value = data[this.ref.trend]

        bar
        .append('rect')
        .attr('id', `BAR_${i}_${this.localId}`)
        .attr('x', d.mx - (this.trend.barSize/2))
        .attr('y', this.trend.height-this.primary.axis(value))
        .attr('width', this.trend.barSize).attr('height', this.primary.axis(value))
        .attr('fill', '#FEED57').attr('opacity', .75)
        
        bar
        .append('text')
        .attr('id', `VALUE_${i}_${this.localId}`)
        .attr('x', d.mx)
        .attr('y', this.trend.height-this.primary.axis(value) - 3)
        .attr('font-size', 9).attr('fill',  value==0 ? '#E0E0DF' : '#757575')
        .attr('text-anchor', 'middle')
        .text(value)
        .call(this.call_Trends, d.name) // ---> Below
      })

      bar
      .append('line')
      .attr('id', `AVG_LINE_${this.localId}`)
      .attr('x1', 0).attr('y1', this.trend.height-this.primary.axis(this.trend.average))
      .attr('x2', this.trend.width).attr('y2', this.trend.height-this.primary.axis(this.trend.average))
      .attr('stroke', '#EC407A').attr('stroke-width', 1).attr('opacity', .5)
    },


    

  }
}